import _ from 'lodash';
import styles from './InfoSection.module.scss';

const InfoSection = (props: any) => {
  let resultIsDoctor = props.resultIsDoctor;

  if (resultIsDoctor) {
    let otherPractices: any[] = [];
    props.secondaryResults.map((element: any) => otherPractices.push(element.practice));
    otherPractices = _.uniq(otherPractices);
    _.remove(otherPractices, _.matches(props.primaryResult.practice));
    return (
      <>
        {/*NPI*/}
        <div className={styles.innerSection2}>
          <div className={styles.sectionHeader2}>NPI:</div>
          <div className={styles.sectionBody2}>{props.primaryResult?.providerNPI}</div>
        </div>
        {/*Specialty*/}
        <div className={styles.innerSection2}>
          <div className={styles.sectionHeader2}>Specialty:</div>
          <div className={styles.sectionBody2}>{props.primaryResult?.specialty}</div>
        </div>
        {/*Phone*/}
        <div className={styles.innerSection2}>
          <div className={styles.sectionHeader2}>Phone:</div>
          <div className={styles.sectionBody2}>{props.primaryResult?.phone}</div>
        </div>
        {/*Fax*/}
        <div className={styles.innerSection2}>
          <div className={styles.sectionHeader2}>Fax:</div>
          <div className={styles.sectionBody2}>{props.primaryResult?.fax}</div>
        </div>
        <div className={styles.innerSection2}>
          <div className={styles.sectionHeader2}>Language:</div>
          <div className={styles.sectionBody2}>{props.primaryResult?.language}</div>
        </div>
        {otherPractices.length === 0 ? (
          <div className={styles.innerSection2}>
            <div className={styles.sectionHeader2}>Practice Affiliations:</div>
            <div className={styles.sectionBody2List}>None</div>
          </div>
        ) : (
          <div className={styles.innerSection2}>
            <div className={styles.sectionHeader2}>Practice Affiliations:</div>
            {otherPractices.map((practice: string, index: number) => (
              <div key={index} id={index.toString()} className={styles.sectionBody2List}>
                {practice}
              </div>
            ))}
          </div>
        )}
        {/*Board Certification*/}
        <div className={styles.innerSection2}>
          <div className={styles.sectionHeader2}>Board Certification:</div>
          <div className={styles.sectionBody2}>{props.primaryResult?.boardCertification}</div>
        </div>
      </>
    );
  }
  return (
    <>
      {/*NPI*/}
      <div className={styles.innerSection}>
        <div className={styles.sectionHeader}>NPI:</div>
        <div className={styles.sectionBody}>{props.primaryResult?.providerNPI}</div>
      </div>
      {/*Specialty*/}
      <div className={styles.innerSection}>
        <div className={styles.sectionHeader}>Specialty:</div>
        <div className={styles.sectionBody}>{props.primaryResult?.specialty}</div>
      </div>
      {/*Phone*/}
      <div className={styles.innerSection}>
        <div className={styles.sectionHeader}>Phone:</div>
        <div className={styles.sectionBody}>{props.primaryResult?.phone}</div>
      </div>
      {/*Fax*/}
      <div className={styles.innerSection}>
        <div className={styles.sectionHeader}>Fax:</div>
        <div className={styles.sectionBody}>{props.primaryResult?.fax}</div>
      </div>
    </>
  );
};

export default InfoSection;
